import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import SimpleBackdrop from './components/Backdrop';
import Menu from './components/Menu';
import { useAuth } from './contexts/AuthContext';
import Configuracoes from './pages/private/Configuracoes';
import Dashboard from './pages/private/Dashboard';
import Integradores from './pages/private/Integradores';
import NovosProjetos from './pages/private/NovosProjetos';
import Orcamentos from './pages/private/Orcamentos';
import Projetos from './pages/private/Projetos';
import Reports from './pages/private/Reports';
import Users from './pages/private/Users';
import Login from './pages/public/Login';

function App() {
  const { user, signOut, loading, isAuthenticated } = useAuth();
  const isAdmin = ['ADMINISTRADOR', 'GERENTE'].includes(user?.role);
  const isManager = user?.role === 'GERENTE';
  const [open, setOpen] = useState(true);

  if (loading) {
    return (
      <div className="App">
        <SimpleBackdrop />
        <ToastContainer
          style={{ zIndex: '9999999' }}
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }

  return (
    <div className="App">
      {isAuthenticated && (
        <Route
          path="/:id2"
          children={
            <Menu
              user={user}
              logoff={() => signOut()}
              abrir={(a) => setOpen(a)}
            />
          }
        />
      )}

      {isAuthenticated ? (
        <div
          style={{
            paddingLeft:
              window.innerWidth < 675 ? '0rem' : open ? '15rem' : '4.5rem',
            paddingTop: window.innerWidth < 675 && '0.75rem',
            transition: '0.25s',
          }}
        >
          <Switch>
            {isAdmin && (
              <Route
                exact
                path={'/dashboard'}
                children={<Dashboard user={user} />}
              />
            )}
            {isAdmin && (
              <Route
                exact
                path={'/projetos'}
                children={<NovosProjetos user={user} />}
              />
            )}

            <Route
              exact
              path={'/integradores'}
              children={<Integradores user={user} />}
            />
            <Route
              exact
              path={'/integradores/projetos/:id'}
              children={<Projetos user={user} />}
            />
            {isManager && (
              <Route
                exact
                path={'/usuarios'}
                children={<Users user={user} />}
              />
            )}
            <Route
              exact
              path={'/configuracoes'}
              children={<Configuracoes user={user} />}
            />
            {isAdmin && (
              <Route
                exact
                path={'/relatorios'}
                children={<Reports user={user} />}
              />
            )}
            {user.role !== 'ADMINISTRADOR' && (
              <Route
                exact
                path={'/orcamentos'}
                children={<Orcamentos user={user} />}
              />
            )}

            <Route exact path={'/login'}>
              <Redirect to="/integradores" />
            </Route>

            <Route exact path={'*'}>
              <Redirect to="/integradores" />
            </Route>
          </Switch>
        </div>
      ) : (
        <Switch>
          <Route exact path={'/login'} children={<Login />} />
          <Route path={'*'}>
            <Redirect to="/login" />
          </Route>
        </Switch>
      )}

      <ToastContainer
        style={{ zIndex: '9999999' }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;